import * as React from "react";
import useModelProviders from "ai-management/hooks/useModelProviders";
const ProviderName = ({ providerId = null }) => {
  var _a;
  const { data: providers } = useModelProviders();
  if (!providerId) {
    return null;
  }
  const provider = providers.find(({ id }) => id === providerId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = provider == null ? void 0 : provider.display) != null ? _a : providerId);
};
export default ProviderName;
